export enum MessageTemplateDetailsTabTypes {
    GENERAL_INFO = "generalInfo",
    CONTENT = "content"
}